<div class="spinner">
    <mat-spinner [diameter]="25"></mat-spinner>
    <p>Loading {{ dataType }}...</p>
</div>
